// Fetch every page even when the API limits the requested page size.
export async function getAllPages(fetchPage, params = {}) {
  const items = [];
  let page = 1;
  let total;

  do {
    const response = await fetchPage({ ...params, page, itemsPerPage: 100 });
    const members = response.data['hydra:member'];
    total = response.data['hydra:totalItems'];
    items.push(...members);
    if (members.length === 0) break;
    page += 1;
  } while (items.length < total);

  return items;
}
